import React from 'react'
import Layout from '../../components/layout/layout'
import { Box, Container, Heading, Section } from 'react-bulma-components'
import SupportEmail from '../../components/support-email/support-email'

export const HelpPage: React.FC = () => {
  return (
    <Layout>
      <Section size="medium">
        <Container max={true} breakpoint={'desktop'} textAlign={'center'}>
          <Heading textColor="primary">Un problème avec TeamTim ?</Heading>
          Notre support répond dans les meilleurs délais à vos demandes et questions.
          <br />
          TeamTim est une plateforme vivante, qui s'améliore chaque jour.
          <br />
          Tout retour de nos utilisateurs est précieux.
          <br /> <br /> <br />
          <Box pb={5}>
            Vous pouvez nous contacter via
            <br /> <br />
            <SupportEmail />
          </Box>
        </Container>
      </Section>
    </Layout>
  )
}
